{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            copyright © 2019                                        }
{            Email : info@tmssoftware.com                            }
{            Web : http://www.tmssoftware.com                        }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.TMSFNCRangeSlider;

{$I WEBLib.TMSFNCDefines.inc}

interface

uses
  Classes,
  {$IFNDEF LCLLIB}
  Types,
  {$ENDIF}
  {$IFDEF FMXLIB}
  FMX.Types,
  {$ENDIF}
  {$IFDEF CMNLIB}
  ExtCtrls,
  {$ENDIF}
  {$IFDEF WEBLIB}
  WEBLib.Controls, WEBLib.ExtCtrls,
  {$ENDIF}
  WEBLib.TMSFNCGraphics, WEBLib.TMSFNCTypes,
  WEBLib.TMSFNCGraphicsTypes, WEBLib.TMSFNCEdit, WEBLib.TMSFNCStyles, WEBLib.TMSFNCTrackBar;

const
  MAJ_VER = 1; // Major version nr.
  MIN_VER = 0; // Minor version nr.
  REL_VER = 0; // Release nr.
  BLD_VER = 1; // Build nr.

  //Version history
  //v1.0.0.0 : First Release
  //v1.0.0.1 : Fixed : Issue with control color in disabled state

type
  TTMSFNCCustomRangeSliderAppearance = class(TTMSFNCCustomTrackBarBaseAppearance)
  published
    property ThumbBitmap;
    property ThumbFill;
    property ThumbStroke;
    property ThumbHeight;
    property ThumbWidth;
    property ThumbDownBitmap;
    property ThumbDownFill;
    property ThumbDownStroke;
    property ThumbShape;
    property ThumbRightBitmap;
    property ThumbRightFill;
    property ThumbRightStroke;
    property ThumbRightHeight;
    property ThumbRightWidth;
    property ThumbRightDownBitmap;
    property ThumbRightDownFill;
    property ThumbRightDownStroke;
    property LineShape;
    property LineBitmap;
    property LineWidth;
    property LineStroke;
    property LineFill;
    property Orientation;
    property TickMarkPosition;
    property TickMarkSize;
    property TickMarkSpacing;
    property TickMarkStroke;
    property TickMarkLabelFormat;
    property TickMarkLabel;
    property TickMarkDivision;
    property TrackLabelFormat;
    property TrackLabelPosition;
  end;

  TTMSFNCCustomRangeSliderInteraction = class(TTMSFNCCustomTrackBarBaseInteraction)
  published
    property Frequency;
  end;

  TTMSFNCCustomRangeSliderValueChanged = procedure(Sender: TObject; AValue: Single; ALeft: Boolean) of object;
  TTMSFNCCustomRangeSliderBeforeDrawThumbEvent = procedure(Sender: TObject; AGraphics: TTMSFNCGraphics; ARect: TRectF; AValue: Single; ALeft: Boolean; var AAllow: Boolean; var ADefaultDraw: Boolean) of object;
  TTMSFNCCustomRangeSliderAfterDrawThumbEvent = procedure(Sender: TObject; AGraphics: TTMSFNCGraphics; ARect: TRectF; AValue: Single; ALeft: Boolean) of object;

  TTMSFNCCustomRangeSlider = class(TTMSFNCCustomTrackBarBase)
  private
    FOnBeforeDrawThumb: TTMSFNCCustomRangeSliderBeforeDrawThumbEvent;
    FOnAfterDrawThumb: TTMSFNCCustomRangeSliderAfterDrawThumbEvent;
    FRangeInteraction: TTMSFNCCustomRangeSliderInteraction;
    FRangeAppearance: TTMSFNCCustomRangeSliderAppearance;
    procedure SetValueLeft(const AValue: Single);
    procedure SetValueRight(const AValue: Single);
    procedure SetRangeInteraction(const AValue: TTMSFNCCustomRangeSliderInteraction);
    procedure SetRangeAppearance(const AValue: TTMSFNCCustomRangeSliderAppearance);
    function IsValueLeftStored: Boolean;
    function IsValueRightStored: Boolean;
    function GetValueLeft: Single;
    function GetValueRight: Single;
  protected
    procedure DrawTrackSliders({%H-}AGraphics: TTMSFNCGraphics; {%H-}ARect: TRectF); override;
    procedure DrawTrackSlider({%H-}AGraphics: TTMSFNCGraphics; {%H-}ARect: TRectF; ALeft: Boolean);
    procedure DoBeforeDrawThumb({%H-}AGraphics: TTMSFNCGraphics; {%H-}ARect: TRectF; AValue: Single; ALeft: Boolean; var AAllow: Boolean; var ADefaultDraw: Boolean); virtual;
    procedure DoAfterDrawThumb({%H-}AGraphics: TTMSFNCGraphics; {%H-}ARect: TRectF; AValue: Single; ALeft: Boolean); virtual;
    procedure RangeInteractionChange(Sender: TObject);
    procedure RangeAppearanceChange(Sender: TObject);
    function GetSliderRect(ALeft: Boolean): TRectF; override;
    function GetThumbWidth: Single; override;
    property Appearance: TTMSFNCCustomRangeSliderAppearance read FRangeAppearance write SetRangeAppearance;
    property Interaction: TTMSFNCCustomRangeSliderInteraction read FRangeInteraction write SetRangeInteraction;
    property ValueLeft: Single read GetValueLeft write SetValueLeft stored IsValueLeftStored nodefault;
    property ValueRight: Single read GetValueRight write SetValueRight stored IsValueRightStored nodefault;
    property OnBeforeDrawThumb: TTMSFNCCustomRangeSliderBeforeDrawThumbEvent read FOnBeforeDrawThumb write FOnBeforeDrawThumb;
    property OnAfterDrawThumb: TTMSFNCCustomRangeSliderAfterDrawThumbEvent read FOnAfterDrawThumb write FOnAfterDrawThumb;
  public
    constructor Create(AOwner: TComponent); override;
    destructor Destroy; override;
  end;

  {$IFNDEF LCLLIB}
  [ComponentPlatformsAttribute(TMSPlatformsWeb)]
  {$ENDIF}
  TTMSFNCRangeSlider = class(TTMSFNCCustomRangeSlider)
  published
    property Appearance;
    property Interaction;
    property Fill;
    property Stroke;
    property Max;
    property Min;
    property ValueLeft;
    property ValueRight;
    property OnChanged;
    property OnBeforeDrawTrackLine;
    property OnAfterDrawTrackLine;
    property OnBeforeDrawTickMarks;
    property OnAfterDrawTickMarks;
    property OnBeforeDrawTickLabel;
    property OnAfterDrawTickLabel;
    property OnBeforeDrawTrackLabel;
    property OnAfterDrawTrackLabel;
    property OnBeforeDrawThumb;
    property OnAfterDrawThumb;
    property OnValueChanged;
  end;

implementation

uses
  Math;

type
  TCustomAppearanceProtected = class(TTMSFNCCustomTrackBarBaseAppearance);

{ TTMSFNCCustomRangeSlider }

constructor TTMSFNCCustomRangeSlider.Create(AOwner: TComponent);
begin
  inherited;
  Width := 150;
  Height := 51;
  FValues.Left := 0.0;
  FValues.Right := 8.0;
  FRangeInteraction := TTMSFNCCustomRangeSliderInteraction.Create(Self);
  FRangeInteraction.OnChange := @RangeInteractionChange;
  FRangeAppearance := TTMSFNCCustomRangeSliderAppearance.Create(Self);
  FRangeAppearance.OnChange := @RangeAppearanceChange;
end;

destructor TTMSFNCCustomRangeSlider.Destroy;
begin
  FRangeInteraction.Free;
  FRangeAppearance.Free;
  inherited;
end;

procedure TTMSFNCCustomRangeSlider.DoAfterDrawThumb(AGraphics: TTMSFNCGraphics;
  ARect: TRectF; AValue: Single; ALeft: Boolean);
begin
  if Assigned(OnAfterDrawThumb) then
    OnAfterDrawThumb(Self, AGraphics, ARect, AValue, ALeft);
end;

procedure TTMSFNCCustomRangeSlider.DoBeforeDrawThumb(AGraphics: TTMSFNCGraphics;
  ARect: TRectF; AValue: Single; ALeft: Boolean; var AAllow, ADefaultDraw: Boolean);
begin
  if Assigned(OnBeforeDrawThumb) then
    OnBeforeDrawThumb(Self, AGraphics, ARect, AValue, ALeft, AAllow, ADefaultDraw);
end;

procedure TTMSFNCCustomRangeSlider.DrawTrackSlider(AGraphics: TTMSFNCGraphics;
  ARect: TRectF; ALeft: Boolean);
var
  b, df: Boolean;
  bmp: TTMSFNCBitmap;
begin
  if ALeft then
  begin
    if FLeftSlider then
    begin
      AGraphics.Fill.Assign(TCustomAppearanceProtected(FAppearance).ThumbDownFill);
      AGraphics.Stroke.Assign(TCustomAppearanceProtected(FAppearance).ThumbDownStroke);
      bmp := TCustomAppearanceProtected(FAppearance).ThumbDownBitmap;
    end
    else
    begin
      AGraphics.Fill.Assign(TCustomAppearanceProtected(FAppearance).ThumbFill);
      AGraphics.Stroke.Assign(TCustomAppearanceProtected(FAppearance).ThumbStroke);
      bmp := TCustomAppearanceProtected(FAppearance).ThumbBitmap;
    end;

    b := True;
    df := True;
    DoBeforeDrawThumb(AGraphics, ARect, FValues.Left, ALeft, b, df);
    if b then
    begin
      if df then
      begin
        case Appearance.ThumbShape of
          tsRectangle: AGraphics.DrawRectangle(ARect);
          tsEllipse: AGraphics.DrawEllipse(ARect);
          tsImage:
          begin
            if Assigned(bmp) then
              AGraphics.DrawBitmap(ARect, bmp);
          end;
        end;
      end;

      DoAfterDrawThumb(AGraphics, ARect, FValues.Left, ALeft);
    end;
  end
  else
  begin
    if FRightSlider then
    begin
      AGraphics.Fill.Assign(TCustomAppearanceProtected(FAppearance).ThumbRightDownFill);
      AGraphics.Stroke.Assign(TCustomAppearanceProtected(FAppearance).ThumbRightDownStroke);
      bmp := TCustomAppearanceProtected(FAppearance).ThumbRightDownBitmap;
    end
    else
    begin
      AGraphics.Fill.Assign(TCustomAppearanceProtected(FAppearance).ThumbRightFill);
      AGraphics.Stroke.Assign(TCustomAppearanceProtected(FAppearance).ThumbRightStroke);
      bmp := TCustomAppearanceProtected(FAppearance).ThumbRightBitmap;
    end;

    b := True;
    df := True;
    DoBeforeDrawThumb(AGraphics, ARect, FValues.Right, ALeft, b, df);
    if b then
    begin
      if df then
      begin
        case Appearance.ThumbShape of
          tsRectangle: AGraphics.DrawRectangle(ARect);
          tsEllipse: AGraphics.DrawEllipse(ARect);
          tsImage:
          begin
            if Assigned(bmp) then
              AGraphics.DrawBitmap(ARect, bmp);
          end;
        end;
      end;

      DoAfterDrawThumb(AGraphics, ARect, FValues.Right, ALeft);
    end;
  end;
end;

procedure TTMSFNCCustomRangeSlider.DrawTrackSliders(AGraphics: TTMSFNCGraphics;
  ARect: TRectF);
var
  rl, rr: TRectF;
begin
  inherited;
  rl := GetSliderRect(True);
  DrawTrackSlider(AGraphics, rl, True);

  rr := GetSliderRect(False);
  DrawTrackSlider(AGraphics, rr, False);
end;

function TTMSFNCCustomRangeSlider.GetValueLeft: Single;
begin
  Result := FValues.Left;
end;

function TTMSFNCCustomRangeSlider.GetValueRight: Single;
begin
  Result := FValues.Right;
end;

function TTMSFNCCustomRangeSlider.IsValueLeftStored: Boolean;
begin
  Result := FValues.Left <> 0.0;
end;

function TTMSFNCCustomRangeSlider.IsValueRightStored: Boolean;
begin
  Result := FValues.Right <> 8.0;
end;

function TTMSFNCCustomRangeSlider.GetSliderRect(ALeft: Boolean): TRectF;
var
  sw: Single;
begin
  Result := inherited;
  if FValues.Left <> FValues.Right then
    Exit;

  if ALeft then
  begin
    sw := Appearance.ThumbWidth / 2;
    case Appearance.Orientation of
      tboHorizontal: OffsetRectEx(Result, -sw, 0);
      tboVertical: OffsetRectEx(Result, 0, sw);
    end;
  end
  else
  begin
    sw := Appearance.ThumbRightWidth / 2;
    case Appearance.Orientation of
      tboHorizontal: OffsetRectEx(Result, sw, 0);
      tboVertical: OffsetRectEx(Result, 0, -sw);
    end;
  end;
end;

function TTMSFNCCustomRangeSlider.GetThumbWidth: Single;
begin
  Result := Math.Max(Appearance.ThumbWidth, Appearance.ThumbRightWidth);
end;

procedure TTMSFNCCustomRangeSlider.RangeAppearanceChange(Sender: TObject);
begin
  FAppearance.Assign(FRangeAppearance);
end;

procedure TTMSFNCCustomRangeSlider.RangeInteractionChange(Sender: TObject);
begin
  FInteraction.Assign(FRangeInteraction);
end;

procedure TTMSFNCCustomRangeSlider.SetValueLeft(const AValue: Single);
begin
  if FValues.Left <> AValue then
  begin
    FValues.Left := AValue;
    DoValuesChanged(FValues.Left, True);
    DoChanged;
  end;
end;

procedure TTMSFNCCustomRangeSlider.SetValueRight(const AValue: Single);
begin
  if FValues.Right <> AValue then
  begin
    FValues.Right := AValue;
    DoValuesChanged(FValues.Right, False);
    DoChanged;
  end;
end;

procedure TTMSFNCCustomRangeSlider.SetRangeAppearance(
  const AValue: TTMSFNCCustomRangeSliderAppearance);
begin
  FRangeAppearance.Assign(AValue);
end;

procedure TTMSFNCCustomRangeSlider.SetRangeInteraction(
  const AValue: TTMSFNCCustomRangeSliderInteraction);
begin
  FRangeInteraction.Assign(AValue);
end;

end.
